import React, {useEffect, useState} from "react";

import {useNavigate} from "react-router-dom";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import {CustomModal, toStandardDate} from "../../../../../utils/UtilFunctions";
import {ViewModalStyles} from "../../../../../styles/CustomModalStyles";
import ViewParticularProjectDetails from "../../DashBoardMapsView/dashboardcomponents/view/ViewParticularProjectDetails";
import View from "../../../../../images/dashboard/View.svg";
import {useLazyQuery} from "@apollo/client";
import {GetProjectDetailsById} from "../../masters/projects/queries/queries";
import {AtsAcLdgrProjects} from "../../masters/projects/queries/types";
import {nodeVar} from "../../../../../utils/commonQueryTypes";
import useUrlParams from "../../../../../customHooks/useUrlParams";
const ParticularProjectDetails = () => {
  const {projectID} = useUrlParams();
  const [viewProjectDetails, setViewProjectDetails] = useState(false);

  const [GetProjectDetail, {data, loading}] = useLazyQuery<
    {node: AtsAcLdgrProjects},
    nodeVar
  >(GetProjectDetailsById);

  useEffect(() => {
    if (projectID)
      GetProjectDetail({
        variables: {
          id: projectID,
        },
      });
  }, [GetProjectDetail, projectID]);
  if (data && data.node && !loading)
    return (
      <>
        <div className="wp-project-details__header">
          <span>Project Details</span>
          <b className="ellipsis-text" title="project_name">
            {data.node.name}
          </b>
          <div className="wp-project-details__header--flex">
            <span>({data.node.supplierName.desc})</span>
            <b className="font-green">
              {toStandardDate(data.node.startDate)} -{" "}
            </b>
            <b className="font-red">{toStandardDate(data.node.endDate)}</b>
            <button
              className="wp-project-details__header--view-project"
              onClick={() => setViewProjectDetails(!viewProjectDetails)}
            >
              View Project Details <img src={EyeWhite} alt="" />
            </button>
            {/* <button className="wp-project-details__header--view-dashboard">
              View Vendor Dashboard <img src={View} alt="" />
            </button> */}
          </div>
        </div>
        <CustomModal
          style={ViewModalStyles}
          isOpen={viewProjectDetails}
          onRequestClose={() => setViewProjectDetails(!viewProjectDetails)}
          contentComponent={
            <ViewParticularProjectDetails
              setModalFlag={setViewProjectDetails}
              projectId={projectID!}
            />
          }
        />
      </>
    );
};

export default ParticularProjectDetails;
